(function () {
  // Set this before body parsing so initial and dynamically rendered controls share the URL opt-in.
  document.documentElement.toggleAttribute('data-pop-shapes-initial-enabled',
    new URLSearchParams(window.location.search).get('portrait_shapes') === '1');
  if (window.PopPrintsPortraitShapes) return;
  const shapes = ['portrait', 'square', 'horizontal'];
  const resolve = (root) => root?.matches?.('[data-personalisation-block]') ? root : root?.querySelector?.('[data-personalisation-block]');
  const getShape = (root) => {
    const value = resolve(root)?.dataset.portraitShape;
    return shapes.includes(value) ? value : 'portrait';
  };
  const syncUploadDockPrice = (block) => {
    const scope = block.closest('[data-testid="product-information"]') || block;
    const price = scope.querySelector('[data-pop-pdp-mobile-upload-dock] .pop-pdp-mobile-upload-dock__price');
    const amount = price?.querySelector('strong');
    if (!amount) return;
    try {
      const config = JSON.parse(block.querySelector('[data-personalisation-config]')?.textContent || '{}');
      const prices = config.portraitShapeStartingPrices;
      if (!prices || !Object.hasOwn(prices, getShape(block))) return;
      const formatted = prices[getShape(block)];
      price.hidden = typeof formatted !== 'string' || !formatted;
      // Shopify's money filter preserves the store's current currency and format.
      if (!price.hidden && amount.innerHTML !== formatted) amount.innerHTML = formatted;
    } catch {}
  };
  const setShape = (root, value, { restore = false } = {}) => {
    const block = resolve(root);
    if (!block || !shapes.includes(value)) return false;
    const previous = getShape(block);
    block.dataset.portraitShape = value;
    const section = block.closest('[data-testid="product-information"]');
    if (section) section.dataset.portraitShape = value;
    block.querySelectorAll('[data-pop-shape-input]').forEach((input) => { input.checked = input.value === value; });
    block.querySelectorAll('[data-pop-shape-current]').forEach((label) => { label.textContent = value[0].toUpperCase() + value.slice(1); });
    block.querySelectorAll('[data-pop-shape-disclosure][open]').forEach((disclosure) => {
      const returnFocus = disclosure.contains(document.activeElement);
      disclosure.open = false;
      if (returnFocus) disclosure.querySelector('summary')?.focus({ preventScroll: true });
    });
    syncUploadDockPrice(block);
    if (previous !== value) block.dispatchEvent(new CustomEvent('pop:portrait-shape-change', {
      bubbles: true, detail: { portraitShape: value, previous, previewThemeId: block.dataset.previewThemeId || '', restore },
    }));
    return true;
  };
  const sizePreset = (key, root) => {
    const shape = getShape(root);
    const sizes = shape === 'square' ? { medium: [12, 12], large: [20, 20] }
      : shape === 'horizontal' ? { small: [12, 8], medium: [16, 12], large: [28, 20], xl: [36, 24] }
      : { small: [8, 12], medium: [12, 16], large: [20, 28], xl: [24, 36] };
    const dimensions = sizes[key];
    if (!dimensions) return null;
    const [width, height] = dimensions;
    const name = { small: 'Small', medium: 'Medium', large: 'Large', xl: 'XL' }[key];
    return { label: `${name} · ${width} × ${height} in`, ratio: `${width} / ${height}`, width, height };
  };
  window.PopPrintsPortraitShapes = { getShape, setShape, sizePreset };
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input?.matches?.('[data-pop-shape-input]') || !input.checked) return;
    setShape(input.closest('[data-personalisation-block]'), input.value);
  });
})();
